import React, { Component } from "react";
import * as _ from "lodash";
import { withTranslation, Trans } from "react-i18next";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { connect } from "react-redux";
import {
  useHistory,
  withRouter,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import SearchBar from "material-ui-search-bar";
import List from "@material-ui/core/List";
import Services from "../../api/api";
import imgUrl from "../../assets/images/imageUrl.js";
import KnowledgeList from "../Knowledge/KnowledgeList";
import KnowledgeCard from "../Knowledge/KnowledgeCard";
import Champion from "./Champion";
import ChampionDetail from "./ChampionDetail";
import Loader from "../loaders/loader";
import { removeSpacetoLowerCase } from "../../api/helper";
import {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
} from "../../redux/actions/appActions";
import OffileDb from '../../config/pouchDB';
import annyang from 'annyang';
import Artyom from 'artyom.js';
// const Jarvis = new Artyom();
import { gaLogEvent } from "../../helpers/analytics";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

var activeTabIndex = 0

class NewKnowledge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      tabList: [],
      list: [],
      orignalList: [],
      isLoading: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.getKnowledgeableDetail = this.getKnowledgeableDetail.bind(this);
    this.speakText = this.speakText.bind(this);
    // this.callannyang = this.callannyang.bind(this);
    this.cancelSearch = this.cancelSearch.bind(this);
  }

  componentDidMount() {
    

    OffileDb.setDatabase()
    console.log("keshhhh:", this.props)
    this.checkActiveTab()
    if (this.props.location.state) {
      this.setState({ isLoading: true, }, () => {
        this.getKnowledgeableDetail(this.props.location.state.id);
      }
      );
    } else if (Object.keys(this.props.selectedComponentObj).length != 0) {
      if (this.props.location.pathname == "/layout/getknowledgeable") {
        if (this.props.selectedComponentObj.new && Object.keys(this.props.selectedComponentObj.new).length != 0) {
          this.getKnowledgeableDetail(this.props.selectedComponentObj.new.id);
        } else {
          //this.getKnowledgeableDetail(this.props.selectedComponentObj.prev.id);
          this.props.history.push("/layout");
        }
      } else {
        if (this.props.selectedComponentObj.new && Object.keys(this.props.selectedComponentObj.new).length != 0) {
          this.getKnowledgeableDetail(this.props.selectedComponentObj.new.id);
        }
      }
    } else {
      this.props.history.push("/layout");
    }
    // this.callannyang()
    
  }

  checkActiveTab() {
    var activetab = JSON.parse(sessionStorage.getItem('activeTab'))
    if (activetab != null && activetab['getknowledgeable'] != undefined) {
      this.setState({
        value: activetab['getknowledgeable'],
      });
    }
  }

  // callannyang(){
  //   var that = this;
  //   annyang.addCallback('resultNoMatch', function(phrases) {
  //     if(phrases != null && phrases.length > 0){
  //       console.log('Speech recognized : ' + phrases[0]);
  //       var triggerFlag = false;
  //       var triggerWords = ["view", "take me", "reveal", "display", "exhibit", "present", "choose", "pick", "select", "open", "show", "click", "direct", "navigate", "home", "buksan", "bukas", "ipakita", "go back", "Open", "play"];

  //       for(var str of triggerWords) {
  //         if(phrases[0].includes(str)){
  //             triggerFlag = true;
  //         }
  //       }
  //       if(triggerFlag === true) {

  //         if(phrases[0].includes("basic") || phrases[0].includes("Basic")) {
  //           if(that.state.value == 0) {
  //             that.props.history.push({
  //               pathname: "/layout/getknowledgeableDetail",
  //               state: that.state.list[0],
  //             });
  //           } else {
  //             that.setState({
  //               value: 0,
  //             });
  //             that.getKnowledgeablSectionData(416)
  //           }
  //           // that.speakText("You are in TB Basics information page")
  //         } else if(phrases[0].includes("update") || phrases[0].includes("Update") || phrases[0].includes("news")) {
  //           if(that.state.value == 0) {
  //             that.props.history.push({
  //               pathname: "/layout/getknowledgeableDetail",
  //               state: that.state.list[1],
  //             });
  //           } else {
  //             that.setState({
  //               value: 0,
  //             });
  //             that.getKnowledgeablSectionData(416)
  //           }
  //           // that.speakText("Here you can view latest news from Stop TB Partnership")
  //         } else if(phrases[0].includes("people affected by TB tab") || phrases[0].includes("second tab") || phrases[0].includes("tab 2") || phrases[0].includes("tap 2")){
  //           that.setState({
  //             value: 1,
  //           });
  //           that.getKnowledgeablSectionData(417)
  //         } else if(phrases[0].includes("message") || phrases[0].includes("survivor") || phrases[0].includes("video")) {
  //           if(that.state.value == 1) {
  //             that.props.history.push({
  //               pathname: "/layout/getknowledgeableDetail",
  //               state: that.state.list[0],
  //             });
  //           } else {
  //             that.setState({
  //               value: 1,
  //             });
  //             that.getKnowledgeablSectionData(417)
  //           }
  //           // that.speakText("Here you can view latest news from Stop TB Partnership")
  //         } else if(phrases[0].includes("medical expert") || phrases[0].includes("first tab") || phrases[0].includes("tab 1") || phrases[0].includes("tap 1")){
  //           that.setState({
  //             value: 0,
  //           });
  //           that.getKnowledgeablSectionData(416)
  //         }
  //       }
  //     }
  //   });
  // }


  speakText(text) {
    console.log("text", text);
    // annyang.abort();
    // let self = this;
    if (window.cordova) {
      document.addEventListener('deviceready', function () {
        window.TTS.speak(text, function () {
          console.log("text::", text);
          // annyang.abort();
        }, function (reason) {
          alert(reason);
        });
      })
    } else {
      // Jarvis.say(text, {onEnd(){
      //   // annyang.abort();
      // }});
    }
    // this.toggleAnnyang();
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   console.log('UNSAFE_componentWillReceiveProps>', nextProps)
  //   if(nextProps.location.state && nextProps.location.state.id) {
  //     this.getKnowledgeableDetail(nextProps.location.state.id);
  //   } else if (Object.keys(nextProps.selectedComponentObj.new).length != 0) {
  //     this.getKnowledgeableDetail(nextProps.selectedComponentObj.new.id);
  //   }
  // }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.state && nextProps.location.state.id) {
      this.getKnowledgeableDetail(nextProps.location.state.id);
    } else if (Object.keys(nextProps.selectedComponentObj).length != 0) {
      if (nextProps.location.pathname == "/layout/getknowledgeable") {
        if (
          this.props.selectedComponentObj.prev &&
          this.props.selectedComponentObj.prev.id
        ) {
          this.getKnowledgeableDetail(nextProps.selectedComponentObj.prev.id);
        } else {
          this.getKnowledgeableDetail(nextProps.selectedComponentObj.new.id);
        }
      } else {
        if (Object.keys(nextProps.selectedComponentObj.new).length != 0) {
          this.getKnowledgeableDetail(nextProps.selectedComponentObj.new.id);
        }
      }
    }
  }

  componentWillUnmount() {
    // this.props.resetSelectedCompnentObject();
  }

  getKnowledgeableDetail(contentid) {
    this.loadOfflineTabData(contentid)
  }

  getKnowledgeableApiDetail(contentid) {
    if (navigator.onLine) {
      let params = {
        communityId: this.props.communityuid,
        contentId: contentid,
        languageId: this.props.langId,
        roleId: JSON.parse(localStorage.getItem("obj")).roleId,
        userId: JSON.parse(localStorage.getItem("obj")).userId,
      };
      
      Services.getRoleWiseContent(params).then((res) => {
        try{
          if (res.data.status == 200) {
            if (res.data.data.childs) {
              this.setState({ tabList: res.data.data.childs })
              this.getKnowledgeablSectionData(res.data.data.childs[activeTabIndex].contentId)
              OffileDb.setData('KnowledgeableTabDetail', res.data.data)
            }
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    }
  }

  getKnowledgeablSectionData(id) {
    this.loadOfflineSectionData(id)
  }

  getKnowledgeablSectionApiData(id){
    if (navigator.onLine) {
      let params = {
        communityId: this.props.communityuid,
        contentId: id,
        languageId: this.props.langId,
        roleId: JSON.parse(localStorage.getItem("obj")).roleId,
        userId: JSON.parse(localStorage.getItem("obj")).userId,
      };
      Services.getRoleWiseContent(params).then((res) => {
        try{
          if (res.data.status == 200) {
            if (res.data.data.childs) {
              this.setState(
                {
                  list: res.data.data.childs,
                  orignalList: res.data.data.childs,
                  isLoading: false,
                },
                () => { }
              );
              OffileDb.setData('KnowledgeableSectionDetail-' + id, res.data.data)
            }
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    }
  }

  loadOfflineTabData(contentid) {
    var that = this
    OffileDb.getData('KnowledgeableTabDetail').then(function (result) {
      if (!result.status && result.status != 404) {
        that.setState({
          tabList: result.data.childs,
          isLoading: false,
        });
        that.loadOfflineSectionData(result.data.childs[that.state.value].contentId)
      } else {
        that.getKnowledgeableApiDetail(contentid)
      }
    });
  }

  loadOfflineSectionData(id) {
    var that = this
    OffileDb.getData('KnowledgeableSectionDetail-' + id).then(function (result) {
      console.log(result)
      try{
        gaLogEvent("Information "+result.data.contentName, '', '');
      }catch(err){
        console.log("err::", err);
      }
      if (!result.status && result.status != 404) {
        that.setState({
          list: result.data.childs,
          orignalList: result.data.childs,
          isLoading: false,
        });
      } else {
        that.getKnowledgeablSectionApiData(id)
      }
    });
  }

  handleChange = (event, newValue) => {
    activeTabIndex = newValue
    this.setState({
      value: newValue,
    });
    this.getKnowledgeablSectionData(this.state.tabList[newValue].contentId)
    sessionStorage.setItem('activeTab', JSON.stringify({ 'getknowledgeable': newValue }))
  };

  handleChangeIndex = (index) => {
    activeTabIndex = index
    this.setState({
      value: index,
    });
    this.getKnowledgeablSectionData(this.state.tabList[index].contentId)
    sessionStorage.setItem('activeTab', JSON.stringify({ 'getknowledgeable': index }))
  };

  handleOnSearch = (e) => {
    let topicList = _.cloneDeep(this.state.orignalList);
    let filtered = [];
    filtered = topicList.filter(function (str) {
      return (
        removeSpacetoLowerCase(str.contentName).indexOf(
          removeSpacetoLowerCase(e)
        ) !== -1
      );
    });


    if (e.length == 0) {
      filtered = _.cloneDeep(this.state.orignalList);
    }
    this.setState({
      list: filtered,
    });
  };

  cancelSearch(e) {
    this.setState({
      list: this.state.orignalList,
    });
  }

  render() {
    const { t } = this.props;
    const { classes, theme } = this.props;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let bgStyles = templateID == 2 ? { background: `url(${this.state.background})` } : {};
    // const theme = useTheme();
    return (
      <div className="gk-page getknowledgeable_page">
        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }
        <div className="gridcontainer">
          <Grid container spacing={3} className="gridcontainer ">
            <div className="text-center getknowledgepagemaindiv">
              <Grid item xs={12} className="gkdivcontent zero getknowledgepagemaindiv">
                <AppBar position="static" color="default" style={colorStyles}>
                  <Tabs
                    value={this.state.value}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    textColor={templateID == 1 ? "primary" : "#fff"}
                    variant="fullWidth"
                    aria-label="full width tabs example"
                  >
                    {
                      this.state.tabList.length > 0 ? (
                        this.state.tabList.map((tabListObj, index) => {
                          return (<Tab label={t(tabListObj.contentName)} {...a11yProps(index)} />)
                        })
                      ) : ('')
                    }
                  </Tabs>
                </AppBar>
                <SwipeableViews
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={this.state.value}
                  onChangeIndex={this.handleChangeIndex}
                  className="infotabcontainer"
                >

                  {
                    this.state.tabList.length > 0 ? (
                      this.state.tabList.map((tabListObj, index) => {
                        return (
                          <>
                            <TabPanel
                              className="bg-knowledge-tab"
                              value={this.state.value}
                              index={index}
                              dir={theme.direction}
                            >
                              {this.state.isLoading ? (
                                <Loader isLoading={this.state.isLoading} />
                              ) : (
                                <>
                                  <SearchBar
                                    placeholder={t('Search')}
                                    className="getaccess-searchbar"
                                    onChange={this.handleOnSearch}
                                    onCancelSearch={this.cancelSearch}
                                  />
                                  <div
                                    className={this.state.list.length == 0 ? "knowledge-white-background" : ""}
                                  >
                                    {!this.state.isLoading &&
                                      this.state.list.length == 0 ? (
                                      <p>{t('No Data Found')}</p>
                                    ) : (
                                      <List className="knowledgable-list knowledge-list">
                                        {this.state.list.map((knowledgeObj, index) => {
                                          return (
                                            templateID == 2 ? <KnowledgeList knowledgeObj={knowledgeObj} /> : <KnowledgeCard knowledgeObj={knowledgeObj} />
                                          );
                                        })}
                                      </List>
                                    )}
                                  </div>
                                </>
                              )}
                            </TabPanel>
                          </>
                        )
                      })
                    ) : ('')
                  }

                </SwipeableViews>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
    );
  }
}

NewKnowledge.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
    selectedBottomComponentObj: storeState.bottomComponentObj,
    componentbgcolor: storeState.componentbgcolor
  };
};

const transNewKnowledge = withTranslation()(NewKnowledge);
const ThemeNewKnowledge = withTheme(transNewKnowledge);
const FinalNewKnowledge = withStyles(useStyles)(ThemeNewKnowledge);
const routeNewKnowledge = withRouter(FinalNewKnowledge);
export default connect(mapStateToProps, {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
})(routeNewKnowledge);
